// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__7pYtD","infoContent":"index_infoContent__yIGoP","desc":"index_desc__a3hSk","list":"index_list__GwI2A"};